<template>
  <div>
    <h3 class="blue-text">{{L10n('rfq')}}</h3>
    <form-edit
      ref="form"
      :data="data"
      :model="getModel"
      @onAutoSave="mixAutoSave"
      @onChangeCompanyID="handleChangeCompanyID"
    />
    <button-line
      @click="handleCreate"
    >
      {{isNew ? L10n('create-rfq') : L10n('new-rfq')}}
    </button-line>
  </div>
</template>

<script>
import { AutoSaveMixin } from '@/mixins/FormAutoSave'
import { ModelRFQ } from '../../models'

export default {
  name: 'index',
  mixins: [AutoSaveMixin],
  components: {
    'form-edit': () => import(/* webpackChunkName: 'QuickRFQPart' */ './Form.vue'),
    'button-line': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ButtonLine.vue')
  },
  props: {
    isNew: { type: Boolean, required: true },
    data: { type: Object, required: true }
  },
  data () {
    return {
      formData: {}
    }
  },
  computed: {
    isAvailableToSave () {
      return !this.isNew
    },
    apiAutoSave () {
      return `RFQs/Patch/${this.data.id}`
    }
  },
  methods: {
    getModel () {
      return ModelRFQ()
    },
    handleChangeCompanyID (id) {
      this.$emit('onChangeCompanyID', id)
    },
    async handleCreate () {
      const form = this.$refs['form']
      try {
        await form.validate()
        if (this.isNew) {
          this.$emit('onCreate', form.getData())
        } else {
          this.$emit('onClone', form.getData())
        }
      } catch (e) {
        this.validateErrorHandler(e)
      }
    },
    mixSuccessAutoSave (_data, settings) {
      this.$emit('update:data', { ...this.data, ..._data })
    },
    mixErrorAutoSave (_data, settings) {
      this.$emit('update:data', { ...this.data })
    }
  }
}
</script>
